/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
    {
        url: "/admin",
        name: "Dashboard",
        slug: "admin",
        icon: "GridIcon",
    },
    {
        url: null,
        name: "Members",
        slug: "members",
        icon: "UsersIcon",
        submenu: [
            {
                url: "/admin/members",
                name: "List of members",
                slug: "members-list",
                icon: "UsersIcon"
            },
            {
                url: "/admin/members/referrals",
                name: "Referrals",
                slug: "members-referrals",
                icon: "UsersIcon",
            },
        ]
    },
    {
        url: "/admin/activity",
        name: "Activity",
        slug: "admin-transactions",
        icon: "DollarSignIcon",
    },
    {
        url: "/admin/withdrawal",
        name: "Withdrawal requests",
        slug: "admin-withdrawal",
        icon: "EditIcon"
    },
]
